module.exports = __webpack_public_path__ + "files/0884ae380a32ea395ab4d1e74af8511c.svg";